<template>
    <div>
        <el-table :data="compare" border style="width:97%">
            <el-table-column label="修改项" prop="name"></el-table-column>
            <el-table-column label="修订后" prop="after">
                <template slot-scope="scope">
                    <span v-html="scope.row.after"></span>
                </template>
            </el-table-column>
            <el-table-column label="修改前" prop="before">
                <template slot-scope="scope">
                    <span v-html="scope.row.before"></span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import Params from "~/config/params";
    export default {
        name: "zj",
        props: {
            edit_content: {
                required: true
            }
        },
        created() {
            this.getCompare();
        },
        data() {
            return {
                title:'修订项',
                compare: [],
                expire_types: [
                    '永久',
                    '7天',
                    '30天',
                    '1分钟测试使用',
                    '1天'
                ]
            }
        },
        methods: {
            getCompare() {
                this.setExpireType();
                this.setQuestionNum();
                this.setDayDownload();
                this.setDownAll();
                this.setPersonDown();
                this.setBatch();
            },
            setExpireType() {
                let day_down = {
                    name: '修改有效期',
                    before: '',
                    after: ''
                };
                if(this.edit_content.content.expire_type != ''){
                    let expire_at = '';
                    if(this.edit_content.content.expire_type == 1){
                        expire_at = Params.timestampToDateTime(this.edit_content.created_at + 86400 * 7);
                    }else if(this.edit_content.content.expire_type == 2){
                        expire_at = Params.timestampToDateTime(this.edit_content.created_at + 86400 * 30);
                    }else if(this.edit_content.content.expire_type == 3){
                        expire_at = Params.timestampToDateTime(this.edit_content.created_at + 60);
                    }else if(this.edit_content.content.expire_type == 4){
                        expire_at = Params.timestampToDateTime(this.edit_content.created_at + 86400);
                    }
                    day_down.after = "<span style='color: red'>" + this.expire_types[this.edit_content.content.expire_type] + "</span> 到期时间：" + expire_at;
                }
                this.compare.push(day_down);
            },
            setQuestionNum() {
                let day = {
                    name: '试题蓝数量设置',
                    before: '',
                    after: ''
                };
                let before = this.edit_content.before_content.question_num;
                let after = this.edit_content.content.limit_configure.question_num;
                if(before !== after){
                    after = "<span style='color: red'>"+after+"</span>";
                }
                day.before = before;
                day.after = after;
                this.compare.push(day);
            },
            setDayDownload() {
                let All = {
                    name: '试卷日下载次数',
                    before: '',
                    after: ''
                }
                let before = this.edit_content.before_content.paper_download;
                let after = this.edit_content.content.limit_configure.paper_download;
                if(before !== after){
                    after = "<span style='color: red'>"+after+"</span>";
                }
                All.before = before;
                All.after = after;
                this.compare.push(All);
            },
            setDownAll() {
                let coin = {
                    name: '下载总次数',
                    before: '',
                    after: ''
                }
                let before =  this.edit_content.before_content.all_download;
                let after =  this.edit_content.content.limit_configure.all_download;
                if(before !== after){
                    after = "<span style='color: red'>"+after+"</span>";
                }
                coin.before = before;
                coin.after = after;
                this.compare.push(coin);
            },
            setPersonDown() {
                let ip = {
                    name: '个人/日下载限制',
                    before: '',
                    after: ''
                };
                let before =  this.edit_content.before_content.single_down_limit;
                let after =  this.edit_content.content.limit_configure.single_down_limit;
                if(before !== after){
                    after = "<span style='color: red'>"+after+"</span>";
                }
                ip.before = before;
                ip.after = after;
                this.compare.push(ip);
            },

            setBatch() {
                this.edit_content.content.limit_configure.batch.map(i => {
                    if (i.subject_id === 0) return;
                    let subject = {
                        name: '',
                        before: '',
                        after: ''
                    }
                    subject.name = i.subject_name;
                    let before = '';
                    let after = '';

                    after += '小学：' + i.config.primary  + '<br/>';
                    after += '初中：' + i.config.middle + "<br/>";
                    after += '高中：' + i.config.high +  '<br/>';

                    let content = this.edit_content.before_content.batch.find(j=>{
                        return j.subject_id == i.subject_id;
                    });
                    before += '小学：' + content.config.primary  + '<br/>';
                    before += '初中：' + content.config.middle + "<br/>";
                    before += '高中：' + content.config.high +  '<br/>';
                    if(before !== after){
                        after = "<span style='color: red'>"+after+"</span>";
                    }
                    subject.before = before;
                    subject.after = after;
                    this.compare.push(subject);

                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/order/recoder/zj.vue